import common from '@page/common/js/common';
import RenderProductListContent from '@page/productListStatic/js/ProductListContent';
import productListUI from '@page/common/js/productList/productListUI';
import $ from 'jquery';

require('sticky-kit/dist/sticky-kit');

window.mercci22.productConfig = {
  templateVersion: 4,
  hasWishList: true,
  sizeSelectorTypeDesktop: 'dropdown',
  imageRenderType: 'modelAndItemAndIg',
  imageBasePath: 'https://image.mercci22.tw/',
  zoomboxData: 'ItemImage',
  refreshDOMs: [
    '.product-photos__model',
    '.product-photos__sns',
    '.product-photos__item',
    '.product-photos__images',
    '.product-size',
  ],
  imgPath: {
    s: 's',
    l: '',
  },
};

RenderProductListContent();

setTimeout(() => {
  $('.items__image').css('opacity', '1');
}, 100);
